import {
  type LazyQueryHookOptions,
  NetworkStatus,
  useApolloClient,
} from '@apollo/client';
import {
  type GetInsuranceByHashQuery,
  type GetInsuranceByHashQueryVariables,
  useGetInsuranceByHashLazyQuery,
} from 'api/core/generated';
import { AppApiVersions, AppSearchParams } from 'app-constants';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useGetInsuranceByHashLazy = (
  options?: LazyQueryHookOptions<
    GetInsuranceByHashQuery,
    GetInsuranceByHashQueryVariables
  >,
) => {
  const client = useApolloClient();
  const [searchParams] = useSearchParams();
  const hash = searchParams.get(AppSearchParams.insuranceHash);

  const [requestInsurance, { data, error, networkStatus }] =
    useGetInsuranceByHashLazyQuery({
      context: {
        apiVersion: AppApiVersions.core,
      },
      ...options,
    });

  const getInsurance = useCallback(() => {
    if (!hash) {
      throw new Error('Hash in url is required on income insurance flow');
    }
    return requestInsurance({
      variables: {
        hash,
      },
    });
  }, [hash, requestInsurance]);

  return {
    insurance: data?.insurance,
    getInsurance,
    insuranceError: error,
    insuranceLoading: networkStatus === NetworkStatus.loading,
    resetInsurance: () => {
      client.cache.evict({ fieldName: 'insurance' });
      client.cache.gc();
    },
  };
};
